{
  "progress_tracker": {
    "title": "Progress Tracker",
    "in_progress": "In Progress",
    "description": "In-progress actions such as adding multiple contacts to lists appear here.",
    "empty_alt": "empty progress tracker",
    "add_contacts_to_list": "Add contacts to the list",
    "add_contacts_count": "Add {{count}} contacts to the list"
  }
}
